import queryString from 'query-string';
import { connect } from 'react-redux'
import { push } from 'react-router-redux';
import { setPayload } from '../../redux/actions/auth';
import { AuthComponent } from '../../components';
import { withRouter } from 'react-router-dom';

const mapDispatchToProps = { push, setPayload };

const mapStateToProps = state => {
  return {
    ...queryString.parse(state.routing.location.search)
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AuthComponent));



// WEBPACK FOOTER //
// ./src/containers/Auth/Auth.js